import { useTranslator } from '../../ccf-translator/ccf-translator';
import ccfLoaderStyles from './ccf-loader.styles';

export interface CcfLoaderProps {
  showLoadingText?: boolean;
  isPrimary?: boolean;
  brandingColor?: string;
}
/**
 * Function to show loader
 * @example - <CcfLoader />
 */
export function CcfLoader(props: CcfLoaderProps) {
  const { showLoadingText, isPrimary, brandingColor } = props;
  const styles = ccfLoaderStyles({ isPrimary, brandingColor });
  const [translate] = useTranslator();
  return (
    <span className={styles.loaderContainer}>
      {showLoadingText && (
        <span className={styles.loaderColor}>{translate('loading')}</span>
      )}
      <ul className={styles.loaderBox}>
        <li className={styles.loaderBar + ' ' + styles.firstLoaderBar}></li>
        <li className={styles.loaderBar + ' ' + styles.secondLoaderBar}></li>
        <li className={styles.loaderBar + ' ' + styles.thirdLoaderBar}></li>
      </ul>
    </span>
  );
}

export default CcfLoader;
